<template>
  <div>
    <span class="sr-only">{{ label }}</span>
    <svg :width="width" :height="height" aria-hidden="true" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.5 59.9999V51.4199H22.108V59.9999H20.5Z" :fill="active ? '#FF0099' : '#B4B5B7'" />
      <path
        d="M24.6317 59.9999V51.4199H27.2357C30.2237 51.4199 31.6757 53.1239 31.6757 55.6199V55.7279C31.6757 58.2239 30.2237 59.9999 27.2117 59.9999H24.6317ZM26.2277 58.7399H27.1637C29.0837 58.7399 30.0077 57.6359 30.0077 55.7399V55.6439C30.0077 53.7959 29.1677 52.6799 27.1517 52.6799H26.2277V58.7399Z"
        :fill="active ? '#FF0099' : '#B4B5B7'"
      />
      <path
        d="M35.5071 59.9999L32.6151 51.4199H34.2831L36.5151 58.3799L38.7591 51.4199H40.2591L37.3551 59.9999H35.5071Z"
        :fill="active ? '#FF0099' : '#B4B5B7'"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M30 48C43.2548 48 54 37.2548 54 24C54 10.7452 43.2548 0 30 0C16.7452 0 6 10.7452 6 24C6 37.2548 16.7452 48 30 48ZM19 9.70968C19 9.31652 19.3165 9 19.7097 9H40.2903C40.6835 9 41 9.31652 41 9.70968V13.1804L36.8211 17.4136L35.8852 16.3796C35.144 15.5607 33.8793 15.4976 33.0603 16.2388C32.2413 16.98 32.1783 18.2448 32.9195 19.0637L36.6949 23.2352L41 18.8741V37.3871C41 37.7803 40.6835 38.0968 40.2903 38.0968H37.25H37.2411C37.2384 36.7567 37.236 35.6088 37.2352 35.5989C37.2211 35.4177 37.1932 35.1646 37.1382 34.8632C37.0288 34.2639 36.8087 33.4545 36.3611 32.6369C35.911 31.8148 35.2277 30.9794 34.1982 30.3526C34 30.2319 33.7906 30.12 33.5696 30.0179C34.1398 29.2816 34.4792 28.3575 34.4792 27.3542C34.4792 24.9494 32.5297 23 30.125 23C27.7203 23 25.7708 24.9494 25.7708 27.3542C25.7708 28.3575 26.1102 29.2816 26.6804 30.0179C26.4594 30.12 26.25 30.2319 26.0518 30.3526C25.0223 30.9794 24.339 31.8148 23.8889 32.6369C23.4413 33.4545 23.2212 34.2639 23.1118 34.8632C23.0568 35.1646 23.029 35.4177 23.0148 35.5989C23.0141 35.6079 23.0237 36.7199 23.0359 38.0968H23.0259H19.7097C19.3165 38.0968 19 37.7803 19 37.3871V9.70968ZM26.0968 12.6129C26.0968 12.2209 26.4145 11.9032 26.8065 11.9032H33.1935C33.5855 11.9032 33.9032 12.2209 33.9032 12.6129C33.9032 13.0049 33.5855 13.3226 33.1935 13.3226H26.8065C26.4145 13.3226 26.0968 13.0049 26.0968 12.6129ZM41 17.0948L36.7343 21.4159L33.8463 18.225C33.5683 17.9178 33.592 17.4436 33.8991 17.1656C34.2062 16.8877 34.6805 16.9113 34.9584 17.2184L36.7816 19.2329L41 14.9597L42.3208 13.6218C42.6118 13.327 43.0866 13.3239 43.3814 13.6149C43.6762 13.9059 43.6792 14.3808 43.3882 14.6756L41 17.0948ZM31.8904 29.4899C32.5045 28.9817 32.8958 28.2136 32.8958 27.3542C32.8958 25.8239 31.6553 24.5833 30.125 24.5833C28.5947 24.5833 27.3542 25.8239 27.3542 27.3542C27.3542 28.2136 27.7455 28.9817 28.3596 29.4899C28.839 29.8866 29.4542 30.125 30.125 30.125C30.7958 30.125 31.411 29.8866 31.8904 29.4899ZM35.6258 38.0968H24.6564C24.6529 36.5463 24.654 35.2318 24.6694 35.1475C24.758 34.6623 24.9337 34.0256 25.2777 33.3972C25.6194 32.7733 26.1235 32.1627 26.8752 31.705C27.2087 31.5019 27.5997 31.3236 28.0594 31.1881C28.674 31.52 29.3775 31.7083 30.125 31.7083C30.8725 31.7083 31.576 31.52 32.1906 31.1881C32.6503 31.3236 33.0413 31.5019 33.3748 31.705C34.1265 32.1627 34.6306 32.7733 34.9723 33.3972C35.3163 34.0256 35.492 34.6623 35.5806 35.1475C35.5974 35.2395 35.6128 36.5939 35.6258 38.0968Z"
        :fill="active ? '#FF0099' : '#B4B5B7'"
      />
    </svg>
  </div>
</template>

<script lang="ts">
export default {
  name: 'IDVBadge',
  props: {
    width: {
      type: Number,
      default: 40,
    },
    height: {
      type: Number,
      default: 40,
    },
    active: {
      type: Boolean,
      default: true,
    },
    hasSimpleLabel: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    label() {
      if (this.hasSimpleLabel) {
        return 'ID Verification';
      }

      return `This user ${this.active ? 'has' : 'has not'} verified their identity`;
    },
  },
};
</script>
